module.exports = __webpack_public_path__ + "img/wzjt.11a52c13.png";